import { render, staticRenderFns } from "./HistoryListContent.vue?vue&type=template&id=7bfd4c51&scoped=true"
import script from "./HistoryListContent.vue?vue&type=script&lang=ts"
export * from "./HistoryListContent.vue?vue&type=script&lang=ts"
import style0 from "./HistoryListContent.vue?vue&type=style&index=0&id=7bfd4c51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd4c51",
  null
  
)

export default component.exports